/**
 * Staff deep links for Whop payments and members.
 *
 * Seller-dashboard paths resolve without the company (`biz_…`) id, so no org
 * config is needed. After login Whop lands on the payment or member page.
 *
 * Receipts are `pay_…`. Members are `mber_…` (company member) or `user_…`
 * (Whop user); both are stored as `customer.whopMemberId`.
 */

const WHOP_DASHBOARD = 'https://whop.com/dashboard';

/** Payment page for a `pay_…` id; undefined for other ids (e.g. `payt_`, `sint_`). */
export function whopReceiptUrl(paymentId?: string | null): string | undefined {
  return paymentId?.startsWith('pay_')
    ? `${WHOP_DASHBOARD}/payments/${paymentId}`
    : undefined;
}

/** Member page for a `mber_…` or `user_…` id; undefined otherwise. */
export function whopMemberUrl(memberId?: string | null): string | undefined {
  if (!memberId) return undefined;
  if (memberId.startsWith('user_')) {
    return `${WHOP_DASHBOARD}/users/${memberId}`;
  }
  if (memberId.startsWith('mber_')) {
    return `${WHOP_DASHBOARD}/members/${memberId}`;
  }
  return undefined;
}
